import React, { Component, Fragment } from 'react'
import swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import store from 'storejs'

import Input from './input'
import Output from './output'
import Doi from './doi'
import Go from './buttons/go'
import NoValidDoiModal from './modals/noValidDoi'
import RequestErrorModal from './modals/requestError'

import http from '../services/http'
import { delay } from '../utils/utils'
import { parseWork } from '../services/workTransformer'
import { TEMPLATES } from '../constants/templates'
import { parseIndex } from '../services/doiParser'

const mySwal = withReactContent(swal)

// 输入的类型
const STATUS_TYPE = {
    TEXT: 'TEXT',
    DOI: 'DOI',
    REFENENCE: 'REFERENCE'
}

/**
 * 将字符串的空行转化为<br />, 并转换为 React 元素
 * 
 * @param {string} str 
 * @returns {React.ReactElement}
 */
const renderText = (str, key) => {
    const content = str
        .split('\n')
        .map((item, innerKey, arr) => {
            // 最后一行不加<br />
            const lineBreak = innerKey === arr.length - 1
                ? ''
                : <br />
            return (
                <span key={innerKey}>
                    {item}
                    {lineBreak}
                </span>
            );
        })
    return <Fragment key={key}>
        {content}
    </Fragment>
}

const renderDoi = (str, key) => {
    return <Doi text={str} key={key} isdoi={true} />
}

const render = (obj, key) => {
    switch (obj.type) {
        case STATUS_TYPE.TEXT:
            return renderText(obj.content, key)
        case STATUS_TYPE.DOI:
            return renderDoi(obj.content, key)
        default:
            return obj.content
    }
}

const parse = (str) => {
    const indexes = parseIndex(str)
    if (indexes.length === 0) {
        return [{
            type: STATUS_TYPE.TEXT,
            content: str,
        }]
    }
    const length = str.length;
    const output = []
    if (indexes[0] > 0) {
        output.push({
            type: STATUS_TYPE.TEXT,
            content: str.slice(0, indexes[0])
        });
    }
    indexes.forEach((pos, idx, arr) => {
        if (idx === arr.length - 1) {
            if (pos !== length) {
                output.push({
                    type: STATUS_TYPE.TEXT,
                    content: str.slice(pos, length)
                })
            }
            return;
        }
        const type = idx % 2 === 0 ? STATUS_TYPE.DOI : STATUS_TYPE.TEXT
        output.push({
            type,
            content: str.slice(pos, arr[idx + 1])
        });
    })
    return output;
}


export default class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input: {
                value: ``,
                disabled: false,
                isLoading: false
            },
            status: [{
                type: STATUS_TYPE.TEXT,
                content: ''
            }],
            output: [renderText('', 0)],
            go: {
                disabled: false
            },
            option: {
                changed: false
            }
        }
        window.addEventListener('optionChanged', () => {
            this.setState({
                option: {
                    changed: true
                }
            })
        })
    }

    showModal = {
        requestError: () => {
            return mySwal({
                html: <RequestErrorModal onClick={() => {
                    mySwal.clickConfirm();
                    this.loading.hide()
                }} />,
                type: "error",
                showConfirmButton: false,
            })
        },
        noValidDoi: () => {
            return mySwal({
                html: <NoValidDoiModal onClick={() => {
                    mySwal.clickConfirm();
                    this.loading.hide()
                }} />,
                type: "error",
                showConfirmButton: false,
            })
        }
    }

    loading = {
        show: () => {
            this.setState({
                input: {
                    isLoading: true
                },
                go: {
                    disabled: true
                }
            })
        },
        hide: () => {
            this.setState({
                input: {
                    isLoading: false
                },
                go: {
                    disabled: false
                }
            })
        }
    }

    handleInput = (val) => {
        this.setState((prevState) => this.transformState(prevState, val))
    }

    transformState = (prevState, val) => {
        const status = parse(val);
        const prevStatus = prevState.status
        const output = [...prevState.output]
        let breakpoint = 0
        for (let key = 0; key < status.length; key++) {
            const isModified = prevStatus[key]
                ? status[key].content !== prevStatus[key].content
                : true
            if (!isModified) {
                status[key] = prevStatus[key];
            } else {
                breakpoint = key;
                break;
            }
        }
        for (let key = 0; key < status.length - breakpoint; key++) {
            const curPos = status.length - 1 - key;
            const prevPos = prevStatus.length - 1 - key;
            const state = status[curPos];
            const isModified = (curPos > 0 && prevPos > 0 && prevStatus[prevPos])
                ? status[curPos].content !== prevStatus[prevPos].content
                : true
            if (!isModified) {
                status[curPos] = prevStatus[prevPos];
            } else {
                output[curPos] = render(state, curPos);
                status[curPos] = state
            }
        }
        return {
            input: {
                value: val || ''
            },
            status: status,
            output: output.slice(0, status.length),
            go: {
                disable: false
            }
        }
    }

    handleSubmit = (submitDelay = 100) => {
        const status = this.state.status
        const output = [...this.state.output]
        const validDoiNum = status.filter(obj => obj.type === STATUS_TYPE.DOI).length
        if (validDoiNum === 0) {
            this.showModal.noValidDoi();
            return;
        }

        if (submitDelay) {
            this.loading.show()
        }

        const outputPromises = status.map((obj, key) => {
            // 解析所有 doi 字符串
            const { type, content: doi } = obj;
            if (type !== STATUS_TYPE.DOI) {
                return null;
            }
            const renderedDoi = output[key] && output[key].props && output[key].props.doi
            if (doi === renderedDoi && this.state.option.changed === false) {
                return null;
            }
            const options = Object.assign({ key }, store.get('settings'))
            return http.getDoi(doi)
                .then(({ info }) => parseWork(info, options))
                .then(data => {
                    output[key] = data
                    this.setState({
                        output
                    })
                })
        })
            .filter(p => p !== null)

        Promise.all([...outputPromises, delay(submitDelay)])
            .catch((err) => {
                console.log(err)
                this.showModal.requestError()
            })
            .finally(() => this.loading.hide())
    }

    componentDidMount() {
        const settings = store.get('settings')
        if (!settings) {
            store.set('settings', TEMPLATES.ACS)
        }
    }

    render() {
        return (
            <main className="main">
                <Input value={this.state.input.value}
                    disabled={this.state.input.disabled}
                    placeholder={`在此处粘贴DOI号，如：\n  [1] 10.1039/c6cc09376k\n  [2] 10.1002/ajoc.201700443`}
                    onInput={this.handleInput}
                    isLoading={this.state.input.isLoading} />
                <Output content={this.state.output} />
                <Go onClick={this.handleSubmit}
                    disabled={this.state.go.disabled} />
            </main>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/main.js